var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"course-background"},[_vm._v("\n    Add a new course below\n")])}
var staticRenderFns = []

export { render, staticRenderFns }